export default {
    alerts: {
        index: {
            error: 'Failed fetching the views',
        },
        store: {
            error: 'Failed creating the view',
            success: 'View created successfully',
        },
        show: {
            error: 'Failed fetching the view',
        },
        update: {
            error: 'Failed updating the view',
            success: 'View updated successfully',
        },
        destroy: {
            error: 'Failed deleting the view',
            success: 'View deleted successfully',
        },
    },
    view: {
        service_appointment: 'Appointment',
        service_appointment_confirmed: 'Appt Confirmed',
        service_appointment_canceled: 'Appt Canceled',
        service_appointment_show: 'Appt Show',
        service_appointment_no_show: 'Appt No Show',
    },
};
